import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import merge from 'deepmerge'

import { typePolicies } from '@/graphql/typePolicies'

const APOLLO_STATE_PROP_NAME = '__APOLLO_STATE__'

let apolloClient: ApolloClient<NormalizedCacheObject>

const initializeApollo = (
  apolloLink?: ApolloLink,
  initialState?: unknown
): ApolloClient<NormalizedCacheObject> => {
  const _apolloClient =
    apolloClient ??
    new ApolloClient({
      ssrMode: typeof window === 'undefined',
      link: apolloLink,
      connectToDevTools: process.env.NODE_ENV === 'development',
      cache: new InMemoryCache({
        typePolicies: {
          ...typePolicies
        }
      })
    })

  if (initialState) {
    const existingCache = _apolloClient.extract()
    const data = merge(initialState, existingCache)
    _apolloClient.cache.restore(data)
  }

  if (typeof window === 'undefined') return _apolloClient
  if (!apolloClient) apolloClient = _apolloClient

  return _apolloClient
}

export { APOLLO_STATE_PROP_NAME, initializeApollo }
